<template>
  <div class="text-xs-center">
      <v-dialog v-model="dialogCompanyPlan" @keydown.enter="dialogCompanyPlan = false" max-width="300" scrollable>
        <v-card>
          <v-card-text justify-center>
            <p class="text-md-center">So é possivel selecionar usuário de empresas parceiras com planos</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn id="companyPlan_confirm" class="mx-0" flat color="primary" @click.native="dialogCompanyPlan = false">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-form ref="form">
        <v-layout wrap justify-center align-center @click="click">
          <v-flex xs12>
            <!-- @keyup.native="keyupUsersIllis" -->
            <!-- :search-input.sync="search" -->
          <v-select
            v-if="showSelect"
            :id="id"
            :content-class="id + '_class'"
            ref="user"
            @change="changeSelectUser"
            @blur="blurSelectUser"
            :rules="rules"
            :clearable="clearable"
            :loading="loadingUsersIllis || loading"
            :disabled="disabled"
            v-model="selectedUsers"
            :placeholder="placeholder"
            :items="items"
            :multiple="multiple"
            chips
            :label="label ? label : 'Selecionar os participantes'"
            item-text="id_text"
            item-value="id"
            :filter="customFilter"
            return-object 
            style="margin-top: 0 !important; padding-top: 6px !important;">
            
            <template v-slot:selection="data">
              <v-chip v-if="data.item.id_text !== 'line'"
                :selected="data.selected"
                :color="multiple ? '' : '#fff'"
                :close="multiple"
                @input="removeUser(data.item)"                        
              >
                <div v-if="companyId == data.item.company_id">
                  <div class="selected-person">
                    <div class="selected-icon" style="margin-top: -6px !important;">
                      <img v-if="data.item.photo_path" :src="`${basePath}uploads/users/${data.item.photo_path}`" alt="avatar">
                      <div v-else class="avatar_user">
                        <h3>{{getFirstLetters(data.item.id_text)}}</h3>
                      </div>
                    </div>
                    <div class="person-company-info">
                      {{ data.item.id_text.split(' ').slice(0, 2).join(' ') | formatAbbreviation(30) }}
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="selected-person">
                    <div class="selected-icon" style="margin-top: -6px !important;">
                      <img v-if="data.item.photo_path" :src="`${basePath}uploads/users/${data.item.photo_path}`" alt="avatar">
                      <div v-else class="avatar_user">
                        <h3>{{getFirstLetters(data.item.id_text)}}</h3>
                      </div>
                    </div>
                    <div class="person-company-info">
                      {{ data.item.id_text | formatAbbreviation(35) }}
                      <div class="selected-company-info">
                        <div class="avatar-chip-connection" v-if="data.item.logo_path">
                          <img :src="`${basePath}uploads/companies/${data.item.logo_path}`" sourcealt='avatar'>
                        </div>
                        <div class="text" v-else>
                          <i class="fas fa-building"></i>
                        </div>
                        {{data.item.company_id_text}}
                      </div>
                    </div>
                  </div>
                </div>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <!-- // @submit.prevent="" usado pois ao apertar enterno campo pesquisar estava atualizando a tela -->
              <v-form autocomplete="off" @submit.prevent="">
                <v-layout align-center>
                  <v-flex grow>
                    <v-list-tile ripple>
                      <v-text-field :id="id+'_search'" :ref="id+'_search'" name="search" @keyup.native="keyupUsersIllis" append-icon="search" label="Pesquisar" v-model="search" :loading="loading"></v-text-field>
                    </v-list-tile>
                  </v-flex>
                  <v-flex shrink>
                    <v-tooltip bottom>
                      <v-btn slot="activator" icon @click="close()">
                        <v-icon>close</v-icon>
                      </v-btn>
                      <span>Fechar</span>                  
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </v-form>
            </template>
            <template v-slot:item="data">
              <template v-if="data.item.id_text === 'line'">
                <v-progress-linear :indeterminate="true"></v-progress-linear>
              </template>
              <template v-else>
                <v-list-tile-avatar>
                  <div v-if="companyId == data.item.company_id">
                    <img dark v-if="data.item.photo_path" class="avatar_image teal_border" :src="`${basePath}uploads/users/${data.item.photo_path}`" alt="avatar">
                    <div dark v-else class="avatar_user teal_border">
                      <h3>{{getFirstLetters(data.item.id_text)}}</h3>
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="data.item.photo_path">
                      <v-tooltip bottom>
                        <template slot="activator">
                          <img v-if="data.item.photo_path" :class="`avatar_image ${(needCompanyPlan ? ((data.item.company_plan == 1) ? 'grey_border' : 'green_border'): '')}`" :src="`${basePath}uploads/users/${data.item.photo_path}`" alt="avatar"> 
                        </template>
                        <span v-if="data.item.company_plan == 1">Empresa com plano grátis</span>
                        <span v-else>Empresa possui plano</span>
                      </v-tooltip>
                    </div>
                    <div v-else>
                      <v-tooltip bottom>
                        <template slot="activator">
                          <div :class="`avatar_user ${(data.item.id && needCompanyPlan ? ((data.item.company_plan == 1) ? 'grey_border' : 'green_border') : '')}`">
                            <h3>{{getFirstLetters(data.item.id_text)}}</h3>
                          </div>
                        </template>
                        <span v-if="data.item.company_plan == 1">Empresa com plano grátis</span>
                        <span v-else>Empresa possui plano</span>
                      </v-tooltip>
                    </div>
                  </div>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.id_text"></v-list-tile-title> 
                    <v-list-tile-sub-title v-if="companyId != data.item.company_id">
                      <v-avatar :size='15'>
                        <div class="company-image" v-if="data.item.logo_path">
                          <img :src="`${basePath}uploads/companies/${data.item.logo_path}`"  alt='avatar' style='width: 15px;'>
                        </div>
                        <div class="company-icon" v-else>
                          <i class="fas fa-building"></i>
                        </div>
                      </v-avatar>
                      {{data.item.company_id_text}}
                    </v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
  // desabilita para poder fazer a verificação sem precisar ter a tipagem certa
  /* eslint-disable eqeqeq */
  import general from '../../mixin/general'
  import rules from '../../mixin/rules'
  import access from '../../mixin/access'

  export default {
    name: 'PSelectUser',
    mixins: [access, general, rules],
    // props: [ 'value', 'rules', 'loading', 'multiple', 'users', 'outCompanyId', 'label', 'disabled', 'itemsNotShow', 'notSearchUserIllis', 'needCompanyPlan' ],
    // notSearchUserIllis = se estiver habilitado busca usuários do sistema, se não busca apenas usuários passados pela props users
    // needCompanyPlan Usado para verificar se o usuário de parceiros so poderam ser adicionados caso a empresa parceira possua plano
    props: {
      id: {default: 'id_user'},
      value: {default: () => { return [] }},
      itemsNotShow: {default: () => { return [] }},
      rules: {},
      // selectedItem representa o item selecionado para acrescentar quando ele não estiver na busca
      selectedItem: {
        default: null
      },
      // usado pois caso tenha team_id busca os usuários de acordo com ele
      teamId: {default: ''},
      loading: {default: false},
      needCompanyPlan: {default: false},
      multiple: {default: false},
      disabled: {default: false},
      clearable: {default: false},
      placeholder: {default: ''},
      // notSearchUserIllis: {default: false},
      // Users são os suuárioq ue veem de fora, quanod esse campo tem itens, naõ é buscado resgistros no banco usando apenas os users, ocorre principalmente quando é selecionado uma equipe e já traz o usuário
      users: {default: () => { return [] }},
      outCompanyId: {default: null},
      label: {default: 'Items'}
    },
    data () {
      return {
        basePath: process.env.API,
        loadingUsersIllis: false,
        dialogCompanyPlan: false,
        // armazena os usuário que busca das outras empresas
        usersOutCompany: [],
        // armazena os usuário que busca da propria empresas
        usersCompany: [],
        companyId: '',
        // substituir users pela props
        items: [],
        setKeyup: null,
        image: '',
        search: '',
        selectedUsers: [],
        // 2 - create, 3 - edit
        view: 2,
        firstClick: true,
        // controla a existencia do select para conseguir fechar ao clicar no close
        showSelect: true,
        blobImage: false
      }
    },
    mounted () {
      // Monta os itens em casos de edição para já mostrar oc ampo preenchido,
      setTimeout(() => {
        this.mountItem()
      }, 8000)
      // Verifica se foi passado valores de empresas de fora, no caso do chat que pode adicionar conecções de outras empresas, caso não tenha passado buscar a empresa logada
      // usa o this.$auth.check() pois caso o usuário não esteja logado não pega a empresa, ocorre em tarefas compartilhadas
      this.companyId = this.outCompanyId ? this.outCompanyId : this.$auth.check() ? this.$auth.user().company_id : 0
    },
    methods: {
      close () {
        // variavel showSelect recebe false e depois true para pdoer fechar o quadro de seleção quando o usuário aperta no x
        this.showSelect = false
        setTimeout(() => {
          this.showSelect = true
        }, 100)
      },
      click () {
        this.search = ''
        // foca o campo de pesquisa quando abre a tela no pc
        if (!this.$vuetify.breakpoint.smAndDown) {
          setTimeout(() => {
            if (this.$refs[this.id + '_search']) this.$nextTick(() => this.$refs[this.id + '_search'].focus())
          }, 300)
        }
        this.loadingUsersIllis = true
        // this.$emit('click')
        // if (this.firstClick) {
        //   this.firstClick = false
        //   if (!this.notSearchUserIllis) {
        // Caso tenha vindo usuários de fora busca eles de acordo com o que foi pesquisado, caso contrario busca no banco
        if (Array.isArray(this.users) && this.users.length > 0) {
          this.setUserCompanyProps()
        } else {
          this.mountItem()
          this.getUsersIllis()
        }
        // }
        // }
      },
      focus () {
        this.$nextTick(() => this.$refs.user.focus())
      },
      validate () {
        return (this.$refs.form && this.$refs.form.validate())
      },
      keyupUsersIllis () {
        this.loadingUsersIllis = true
        // if (!this.notSearchUserIllis) {
        // Caso tenha vindo usuários de fora busca eles de acordo com o que foi pesquisado, caso contrario busca no banco
        if (Array.isArray(this.users) && this.users.length > 0) {
          this.setUserCompanyProps()
        } else {
          clearTimeout(this.setKeyup)
          this.mountItem()
          this.setKeyup = setTimeout(this.getUsersIllis, 1500)
        }
      },
      setUserCompanyProps () {
        this.usersCompany = this.search == '' ? this.users : this.users.filter((val) => {
          const hasValue = val => val != null ? val : ''
          const search = hasValue(this.search).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          const text = hasValue(val['id_text']).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') + ' ' + hasValue(val['email']).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          return text.indexOf(search) > -1
        })
        this.mountItem()
        this.loadingUsersIllis = false
      },
      removeUser (item) {
        this.selectedUsers.splice(this.selectedUsers.findIndex((val) => {
          return val.id === item.id
        }), 1)
        this.$emit('input', this.selectedUsers)
      },
      getUsersIllis () {
        this.loadingUsersIllis = true
        this.$http.get(`api/get_users_illis?company_id=${this.companyId}&team_ids=${this.teamId || ''}&search=${this.search || ''}`).then((res) => {
          this.usersOutCompany = res.body['outCompany']
          this.usersCompany = res.body['company']
          this.loadingUsersIllis = false
          this.mountItem()
        }, err => {
          console.log(err)
          this.loadingUsersIllis = false
          this.mountItem()
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar os registros, reporte o erro.', color: 'error', dialog: true})
        })
      },
      blurSelectUser () {
        this.$emit('blur')
      },
      changeSelectUser (val) {
        setTimeout(() => {
          if (typeof val === 'undefined') {
            this.selectedUsers = null
          } else if (Array.isArray(val)) {
            // Se for array verifica verifica se n foi clicado na linha de carregamento, se tiver sido tira ela
            if (val.find((v) => { return v.id_text === 'line' })) this.removeUser(val.find((v) => { return v.id_text === 'line' }))
            // Verifica plano para mandar msg e não permitir quando seleciona um usuário de empresa que está no palno grátis
            var item = val.find((v) => { return v.company_plan == 1 })
            if (item) this.verifyCompanyPlan(item)
          } else {
            // Se for sem multiple verifica verifica se n foi clicado na linha de carregamento, se tiver sido tira ela
            if (val['id_text'] === 'line') this.selectedUsers = null
            // Verifica plano para mandar msg e não permitir quando seleciona um usuário de empresa que está no palno grátis
            if (val.company_plan == 1) this.verifyCompanyPlan(val)
          }
          // MOnta novamente a lista de itens
          this.$emit('input', this.selectedUsers)
          this.mountItem()
          this.search = ''
          this.$emit('change', this.selectedUsers)
        }, 10)
      },
      verifyCompanyPlan (item) {
        // So verifica se a empresa tiver plano se a propriedade needCompanyPlan for true
        if (this.needCompanyPlan) {
          this.dialogCompanyPlan = true
          if (this.multiple) {
            this.removeUser(item)
          } else {
            this.selectedUsers = null
            this.$emit('input', null)
          }
        }
      },
      // Usado para não usar o filtro do componente autocomplete
      customFilter (item, queryText, iText) {
        let itemText = item.id_text + ' ' + item.company_id_text
        const hasValue = val => val != null ? val : ''
        const text = hasValue(itemText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        const search = hasValue(this.search).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        return text.indexOf(search) > -1 || item['type'] == 0
      },
      mountItem () {
        this.items = []
        if (this.selectedItem && this.selectedItem['user_id'] > 0 && !this.usersCompany.some((val) => { return val.id == this.selectedItem['id'] })) {
          this.usersCompany.unshift(this.selectedItem)
        }
        // if (this.notSearchUserIllis || this.users.length > 0) {
        // this.usersOutCompany.length == 0 Significa que não chegou a buscar os usuários porem não tem usuários de outra empresa, vindo como participantes apenas
        if (this.users.length > 0 || this.usersOutCompany.length == 0) {
          // foi incluido o id: 0 para eles passarem pelo filtro e mostrar quando o usuário filtra
          this.items = [{ id: 'header1', type: 0, header: 'Participantes' }]
          this.setSelectedItems(this.usersCompany)
          Array.prototype.push.apply(this.items, JSON.parse(JSON.stringify(this.usersCompany || [])))
        } else {
          // foi incluido o id: 0 para eles passarem pelo filtro e mostrar quando o usuário filtra
          this.items = [{ id: 'header1', type: 0, header: 'Própria Empresa' }]
          // Criado para monta os items
          this.setSelectedItems(this.usersCompany)
          Array.prototype.push.apply(this.items, JSON.parse(JSON.stringify(this.usersCompany || [])))
          Array.prototype.push.apply(this.items, [{ id: 'divider', type: 0, divider: true }, { id: 'header2', type: 0, header: 'Usuários Parceiros' }])
          if (this.loadingUsersIllis) Array.prototype.push.apply(this.items, [{ id: 'line', type: 0, id_text: 'line' }])
          // selectedUsers Variavel criada para armazenar os valores que estão selecionados e não tira los da lista, necessario quando vai ed
          // this.setSelectedItems = CAso tenha valores selecionados que devido ao filtro não estão na lista, adiciona-los manualmente
          var selectedUsers = this.setSelectedItems(this.usersOutCompany)
          Array.prototype.push.apply(this.items, JSON.parse(JSON.stringify(this.usersOutCompany || [])))
          Array.prototype.push.apply(this.items, [{ id: 'search', type: 0, header: 'Digite para encontrar usuários parceiros' }])
        }
        // filtra os itens que não são pra ser mostrados, como itens que já foram adicionados
        if (this.itemsNotShow.length > 0) {
          this.items = this.items.filter((item) => {
            // return !this.itemsNotShow.some((id) => { return id === item.id })
            // passa por todos os itens que não podem mostrar e verifica se aquele item existe na lista de itens ou se ele está selecionado
            return !this.itemsNotShow.some((id) => { return id === item.id && ((!selectedUsers) || !selectedUsers.includes(id)) })
          })
        }
      },
      setSelectedItems (items = [], selectedItem = this.selectedUsers) {
        // Variavel criada para armazenar os valores que estão selecionados e não tira los da lista, necessario quando vai ed
        var selectedUsers = []
        // CAso tenha valores selecionados que devido ao filtro não estão na lista, adiciona-los manualmente
        if (selectedItem !== null) {
          if (Array.isArray(selectedItem) && selectedItem.length > 0) {
            selectedItem.map((user) => {
              if (user.company_id !== this.company_id && !items.some((val) => { return user.id === val.id })) {
                items.unshift(user)
                selectedUsers.unshift(user.id)
              }
            })
          } else if ((typeof selectedItem) === 'object' && selectedItem.hasOwnProperty('id')) {
            if (selectedItem.company_id !== this.company_id && !items.some((val) => { return selectedItem.id === val.id })) {
              items.unshift(selectedItem)
              selectedUsers.unshift(selectedItem.id)
            }
          }
        }
        return selectedUsers
      }
    },
    watch: {
      // caso seja alterado o usuário deverá ser alterado os items pelo mountItem para mostra nas opções
      users () {
        this.mountItem()
      },
      // caso o usuário de fora sejá alterado, tbm alterar o do PSelectUser
      value: {
        immediate: true,
        handler (val, oldVal) {
          if (val != this.selectedUsers) {
            this.selectedUsers = val
            this.mountItem()
          }
        }
      }
    }
  }
</script>

<style scoped>
  .avatar_image{
    height: 38px;
    width: 38px;  
  }

  .avatar_user{
    background: #00acc2;
    border-radius: 50%;
    height: 38px;
    width: 38px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .company-image{
    height: 15px;
    width: 15px;
  }

  .company-icon{
    height: 15px;
    width: 15px;
    color: #00acc2;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .teal_border{
    border: 2px solid #00acc2;
  }

  .grey_border{
    border: 4px solid #888;
  }

  .yellow_border{
    border: 4px solid #ece92c;
  }

  .green_border{
    border: 4px solid #15df03;
  }

  .v-chip--selected{
    box-shadow:none;
  }

  .v-chip--selected::after{
    background: none;
  }
  
  .selected-person{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    padding-bottom: 5px;
  }

  .selected-icon{
    margin-right: 6px;
  }

  .selected-icon img{
    height: 28px;
    width: 28px;
    border-radius: 50%;
  }

  .selected-icon .avatar_user{
    height: 28px;
    width: 28px;
  }

  .person-company-info{
    display: flex;
    flex-direction: column;
    align-items: left;
  }

  .selected-company-info{
    display: flex;
  }

  .selected-company-info img{
    width: 14px;
    height: 14px;
    border-radius: 5px;
  }

  .selected-company-info .avatar-chip-connection,
  .selected-company-info .text{
    margin-right: 6px;
    color: #00acc2;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PSelectUser.vue